import { MenuAccess } from './types';
import { AppSetting } from 'dependencies/appsettings';
import { ShellState, AuthState, AccessInfoData, AccessAdminInfoData } from 'app/types-shared';

export function userInfoNotLoaded(state: ShellState) {
  return state.authState === AuthState.Authenticated && !state.fetching && (!state.userInfo || !state.userInfo.id);
}

export function userIsLoggedIn(state: ShellState) {
  return state.authState === AuthState.Authenticated && state.userInfo && state.userInfo.id;
}

const hasAdminReadAccess = (feature?: Pick<AccessAdminInfoData, 'read'>) =>
  Boolean(AppSetting.AdminApiBaseUrl && feature?.read);

const hasCentralAdminAccess = (feature?: Pick<AccessAdminInfoData, 'administrationCentral'>) =>
  Boolean(AppSetting.AdminApiBaseUrl && feature?.administrationCentral);

const hasAccess = (enabled?: boolean) => enabled;

export const getMenuAccess = (accessData: AccessInfoData): MenuAccess => ({
  codetableAdministration: hasAdminReadAccess(accessData?.adminPanel?.codetable),
  userAdministration: hasAdminReadAccess(accessData?.adminPanel?.user),
  roleAdministration: hasAdminReadAccess(accessData?.adminPanel?.role),
  dashboardAdministration: hasCentralAdminAccess(accessData?.adminPanel?.dashboard),
  companyReportAdministration: hasCentralAdminAccess(accessData?.adminPanel?.companyReport),
  favouriteAdministration: hasCentralAdminAccess(accessData?.adminPanel?.favourite),
  messageAdministration: hasAdminReadAccess(accessData?.adminPanel?.message),
  textConfiguration: hasCentralAdminAccess(accessData?.adminPanel?.translation),
  importSetsAdministration: hasCentralAdminAccess(accessData?.adminPanel?.interfaceAdministration),
  externalUrlAdministration: hasCentralAdminAccess(accessData?.adminPanel?.externalUrl),
  subscriberGroupAdministration: hasCentralAdminAccess(accessData?.adminPanel?.subscriberGroup),
  experienceTransferAdministration: hasCentralAdminAccess(accessData?.adminPanel?.experienceTransfer),
  refreshCache: hasAccess(accessData?.tools?.refreshCache),
  imports: hasAccess(accessData?.tools?.exportAndImport?.import),
  regenerateAggregatedData: hasAccess(accessData?.tools?.regenerateAggregatedData),
  manageSurveys: hasAccess(accessData?.surveyManager?.edit),
  systemConfigurationTool: hasAccess(accessData?.tools?.systemConfigurationTool)
});
